<template>
  <div class="topic-news-container">
    <div class="topic-news-content" v-if="columnList.length > 0">
      <van-tabs animated :swipe-threshold="3" :ellipsis="false" v-model="activeIndex">
        <van-tab v-for="(item, index) in columnList" :key="index" :title="item.name">
          <ul>
            <li
              v-for="value in newsList[index].articleList"
              :key="value.id"
              @click="clickNews(value, clickTag2)"
            >
              <div class="time">{{ value.addTime | formatTime }}</div>
              <div class="news-title">{{ value.title }}</div>
            </li>
          </ul>
          <div class="title-more" @click="clickMore(activeIndex, clickTag1)">查看更多</div>
        </van-tab>
      </van-tabs>
    </div>

    <div class="my-tip" v-else>
      <img :src="nullPng" alt="" />
      <p>当前暂无内容~</p>
    </div>
  </div>
</template>

<script>
import codes from '@/api/codes';
import { configureParams } from '@/assets/js/configureParams';
import nullPng from '../../../static/image/null.png';
export default {
  name: 'TopicNews',
  data() {
    return {
      ids: [
        codes.STATE_GRID_INFO,
        codes.MEDIA_FOCUS,
        codes.GRASSROOTS_DYNAMICS,
        codes.INDUSTRY_NEWS,
        codes.FIRST_LINE_STYLE,
        codes.COMPANY_NEWSPAPER,
        codes.VIDEO_MATERIAL,
      ],
      videoColumn: codes.VIDEO_MATERIAL,
      columnList: [], // 所有栏目
      newsList: [], // 所有栏目下的文章
      activeIndex: 0, // 当前被激活tab的索引
      clickTag1: codes.MENU, // 标记点击的是菜单
      clickTag2: codes.ARTICLE, // 标记点击的是新闻文章
      nullPng,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 获取所有栏目的信息
    // 1.栏目的详情
    // 2.栏目下的文章
    init() {
      let requests1 = [];
      let replacement = {
        subjectId: codes.SUBJECT_ID,
      };
      let pageId = 1;
      let pageSize = 5;
      let requests2 = [];
      requests1 = this.ids.map((id) => {
        return this.$api.postMenuArticle(replacement, [id], pageId, pageSize);
      });
      requests2 = this.ids.map((id) => {
        let replacement2 = {
          subjectId: codes.SUBJECT_ID,
          menuId: id,
        };
        return this.$api.getMenuSelfInfo(replacement2);
      });
      Promise.all(requests1)
        .then((result) => {
          this.newsList = result;
          return Promise.all(requests2);
        })
        .then((rs) => {
          this.columnList = rs;
        });
    },

    // 点击更多跳转到当前栏目
    clickMore(activeIndex, clickTag) {
      // 获取栏目的菜单结构(每层菜单中的第一个)
      if (this.columnList.length > 0) {
        let replacement = {
          subjectId: codes.SUBJECT_ID,
          menuId: this.columnList[activeIndex].id,
        };
        this.$api.getMenuLevels(replacement).then((data) => {
          this.$router.push({
            path: '/content',
            query: configureParams(data, this.columnList[activeIndex], clickTag),
          });
        });
      }
    },

    // 点击新闻
    clickNews(articleData, clickTag) {
      let replacement = {
        subjectId: codes.SUBJECT_ID,
        articleId: articleData.id,
      };
      // this.$api.countClick(replacement)
      //   .then(data => {
      //     // 获取文章的上级菜单结构
      //     return this.$api.getArticleUpMenus(replacement)
      //   })
      this.$api.getArticleUpMenus(replacement).then((data) => {
        this.$router.push({
          path: '/content',
          query: configureParams(data, articleData, clickTag),
        });
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/common.scss';

.topic-news-container {
  padding: 0 40px;
  margin-top: 70px;

  .my-tip {
    height: calc-width(382vw);
    padding-top: calc-width(60vw);
    box-sizing: border-box;
    text-align: center;
    color: #ababab;
    background: rgba(255, 255, 255, 1);
  }

  .topic-news-content {
    .title-more {
      margin-top: 36px;
      font-size: 26px;
      font-weight: 400;
      color: #3a8bf3;
      line-height: 37px;
      text-align: center;
    }

    .van-tabs--line .van-tabs__wrap {
      height: 80px;
      padding: 0 18px;
    }

    .van-tabs__line {
      display: none;
    }

    [class*='van-hairline']::after {
      border: unset;
    }

    .van-tab {
      font-size: 42px;
      font-weight: 500;
      color: #333333;
      line-height: 59px;
      padding: 0;
      margin-right: 60px;

      &:last-child {
        margin-right: 0;
      }
    }

    .van-tab.van-tab--active {
      border-bottom: 3px solid $primary-color;
    }

    ul {
      margin-top: 50px;
      li {
        padding: 22px 0 18px;
        border-bottom: 1px solid #e4e4e4;

        .time {
          font-size: 24px;
          font-weight: 400;
          color: #a0a0a0;
          line-height: 33px;
        }
        .news-title {
          margin-top: 6px;
          font-size: 30px;
          font-weight: 400;
          color: #575757;
          line-height: 42px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/TopicNews.vue